import isMeetingOnCalendarSharedWithMe from './isMeetingOnCalendarSharedWithMe';
import isOnGroupCalendar from './isOnGroupCalendar';
import { CalendarEvent } from 'owa-calendar-types';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Returns true if event can be acted on "from this date forward"
 * This happens if flight is on and event is not on shared calendar
 * @param event Calendar event
 */
export default function canActFromThisDateForward(event: CalendarEvent): boolean {
    if (!isFeatureEnabled('cal-recurrenceThisDateForward')) {
        // if cal-recurrenceThisDateForward flight is off, then return false
        return false;
    }

    if (isOnGroupCalendar(event)) {
        // if the event is on group calendar, then enable FTDF if cal-groupNotifications flight is on
        return isFeatureEnabled('cal-groupNotifications');
    }

    if (isMeetingOnCalendarSharedWithMe(event)) {
        // If it's a shared calendar, then enable FTDF if the flight cal-mf-enableFTDFOnSharedCalendar is on
        return isFeatureEnabled('cal-mf-enableFTDFOnSharedCalendar');
    }

    return true;
}
